import { render, staticRenderFns } from "./folders.vue?vue&type=template&id=5a773751"
import script from "./folders.vue?vue&type=script&lang=js"
export * from "./folders.vue?vue&type=script&lang=js"
import style0 from "./folders.vue?vue&type=style&index=0&id=5a773751&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports